"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("./index");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var payload = function payload(values) {
  if ((0, _index.isCustom)(values.type)) {
    return {
      type: values.type,
      output: values.reportHeader,
      label: values.label,
      appendInput: true
    };
  }
  var args = values.type === _index.IF_THEN ? values.ifThen : _objectSpread(_objectSpread({
    n_input: values.calculateCondition === 'all' ? values.variables.length : values.minimumAnswers
  }, typeof values.minimum === 'number' ? {
    minimum: values.minimum
  } : null), typeof values.maximum === 'number' ? {
    maximum: values.maximum
  } : null);
  var input = values.type === _index.IF_THEN ? ifThenInput(values.ifThen.conditions) : values.variables;
  return {
    valueType: 'double',
    type: values.type,
    input: input,
    output: values.reportHeader,
    label: values.label,
    args: args
  };
};
var ifThenInput = function ifThenInput(conditions) {
  var result = {};
  conditions.forEach(function (condition) {
    return getConditionInput(condition.condition, result);
  });
  return Object.values(result);
};
var getConditionInput = function getConditionInput(condition, result) {
  return condition.conditions.forEach(function (c) {
    if ('dataConnector' in c) {
      result[c.dataConnector.id] = c.dataConnector.id;
    }
    if ('conditions' in c) {
      getConditionInput(c, result);
    }
  });
};
var _default = payload;
exports["default"] = _default;